import { createAction, props } from '@ngrx/store';

export const setMaxPages = createAction(
  '[Pagination] Set Max Pages',
  props<{ maxPages: number }>(),
);

export const setMaxPagesSuccess = createAction(
  '[Pagination] Set Max Pages Success',
  props<{ maxPagesData: number }>(),
);

export const setPerPage = createAction(
  '[Pagination] Set Per Page',
  props<{ perPage: number }>(),
);

export const setPerPageSuccess = createAction(
  '[Pagination] Set Per Page Success',
  props<{ perPageData: number }>(),
);
